import { render, staticRenderFns } from "./AddPVC.vue?vue&type=template&id=0b11e6c8&"
import script from "./AddPVC.vue?vue&type=script&lang=js&"
export * from "./AddPVC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports